import React from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CopyInputField } from "@rentablo/components";
import { TypographyWithInfoIcon } from "@rentablo/components";
import { useMyself } from "@api/v1/hooks/useMyself";

export const UserIdField = ({ marginBottom }: { marginBottom?: number }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { data } = useMyself();
  const userId = data?.id?.toString();

  if (!userId) return null;

  return (
    <Box mb={marginBottom} ml={2} color={theme.palette.sidebar.textOnSidebar}>
      <Box mb={1.5}>
        <TypographyWithInfoIcon
          variant="overline"
          color="inherit"
          tooltipText={t("settings.sidebar.userId.tooltip")}
          tooltipSmall
          iconColor="inherit"
        >
          {t("settings.sidebar.userId.label")}
        </TypographyWithInfoIcon>
      </Box>
      <CopyInputField
        value={userId}
        color={theme.palette.sidebar.textOnSidebar}
      />
    </Box>
  );
};
